import { fromDotObject } from "../../../utils/dotObject";
import mergeDocumentData from "../../../utils/mergeDocumentData";

import articleDeliveryStatuses from "../constants/articleDeliveryStatuses";
import getPublicationStatus from "../getPublicationStatus";
import getPublicationStatusByPriority from "../getPublicationStatusByPriority";

export default function updateArticlePublicationStatus(article, data, { publisher } = {}) {
	const mergedArticle = mergeDocumentData(article, data);

	if (data.channels) {
		// Update publication status for channels that have completed delivery
		data = Object.entries(data?.channels || {})
			.filter(([_, channelData]) => {
				return (
					channelData?.delivery?.metadata?.status === articleDeliveryStatuses.DELIVERY_COMPLETED ||
					channelData?.delivery?.artifact?.status === articleDeliveryStatuses.DELIVERY_COMPLETED
				);
			})
			.reduce((data, [channelId]) => {
				return fromDotObject({
					...data,
					[`channels.${channelId}.publicationStatus`]: getPublicationStatus({
						article: mergedArticle,
						channelId: channelId,
					}),
				});
			}, data);
	}

	if (data.channelIds && article.channelIds?.length > 0) {
		// Update publication status for channels that were disabled
		const removedChannelIds = article.channelIds.filter((channelId) => !data.channelIds.includes(channelId));
		data = removedChannelIds.reduce((data, channelId) => {
			return fromDotObject({
				...data,
				[`channels.${channelId}.publicationStatus`]: getPublicationStatus({
					article: mergedArticle,
					channelId: channelId,
				}),
			});
		}, data);
	}

	const mergedArticleAgain = mergeDocumentData(mergedArticle, data);

	return {
		...data,
		publicationStatus: getPublicationStatusByPriority({ article: mergedArticleAgain, publisher }),
	};
}
